import React from "react";
import "./Love.css";
const Love = () => {
  return (
    <div className="my_love">
      <h2 className="love_line">I Love ❤️</h2>
      <ul>
        <li>
          <h4>Coding</h4>
        </li>
        <li>
          <h4>learning</h4>
        </li>
        <li>
          <h4>Music</h4>
        </li>
        <li>
          <h4>Playing</h4>
        </li>
        <li>
          <h4>Reading</h4>
        </li>
      </ul>
    </div>
  );
};

export default Love;
